import React from 'react';

function fmtMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+s}

class AudioTimer extends React.Component {
  constructor(props) {
    super(props);
    console.log("AudioTimer constructor");
    this.state = {
      timer: '',
      clickArea: props.clickArea,
      force_timerCount: props.force_timerCount
    };
    this.audioTimer_handler = props.audioTimer_handler;
    this.seconds_per_slide = props.seconds_per_slide;
    this.required_slide_count = props.required_slide_count;
    this.timerCount = 0;
    this.start_interval_time = 0;
    this.start_timer_count = 0;
    this.interval_ms = 50;
    this.delay_constant = -20; // for some reason the audio ends up 19.92s instead of 20s
    this.interval = null; // for setInterval
  }
  
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  
  componentDidUpdate() {
    // we only want to do things here if we got changes from props
    if (this.props.force_timerCount === this.state.force_timerCount && this.props.clickArea === this.state.clickArea) {
      return;
    }
    
    let force_timerCount = this.props.force_timerCount;
    let clickArea = this.props.clickArea;
    console.log("AudioTimer componentDidUpdate some props",force_timerCount,clickArea);
    
    this.setState({
      force_timerCount: null, // this is a one-time-trigger
      clickArea
    });
    
    let timePrint = '';
    
    if (force_timerCount !== null) {
      this.timerCount = force_timerCount * 1000;
      this.start_timer_count = force_timerCount * 1000;
    }
    
    if (clickArea) {

      if (clickArea === 'recording') {
        // update quickly once
        timePrint = fmtMSS(Math.floor(this.timerCount / 1000));
        let tmp_slide_number = Math.floor((this.timerCount / 1000) / this.seconds_per_slide) + 1;
        if (tmp_slide_number > this.required_slide_count) {
          this.setState({timer:'Final Remarks - '+timePrint});
        } else {
          this.setState({timer:'Recording - Slide '+tmp_slide_number+' - '+timePrint});
        }
        this.audioTimer_handler(this.timerCount);
        
        // set start_interval_time right before setInterval
        this.start_interval_time = new Date();
        
        this.interval = setInterval(() => {
          //this.timerCount = this.timerCount + (this.interval_ms / 1000);
          let current = new Date();
          this.timerCount = this.start_timer_count + this.delay_constant + (current - this.start_interval_time);
          timePrint = fmtMSS(Math.floor(this.timerCount / 1000));
          let tmp_slide_number = Math.floor((this.timerCount / 1000) / this.seconds_per_slide) + 1;
          if (tmp_slide_number > this.required_slide_count) {
            this.setState({timer:'Final Remarks - '+timePrint});
          } else {
            this.setState({timer:'Recording - Slide '+tmp_slide_number+' - '+timePrint});
          }
          //console.log("AudioTimer Interval",timerCount);
          this.audioTimer_handler(this.timerCount);
        }, this.interval_ms); 

      } else if (clickArea === 'paused') {
        // really we are not recording, between slides
        clearInterval(this.interval);
        let tmp_slide_number = Math.floor(this.timerCount / this.seconds_per_slide) + 1;
        this.timerCount = this.timerCount - (this.timerCount % this.seconds_per_slide);
        timePrint = fmtMSS(Math.floor(this.timerCount));
        //this.setState({timer:'Slide '+tmp_slide_number});
        this.setState({timer:''});
        this.audioTimer_handler(this.timerCount);
      } else if (clickArea === 'inactive') {
        // all 20 slides done
        clearInterval(this.interval);
        this.setState({timer:'Finished Recording'});
        this.timerCount = 0;
      }
    } else {
      // restart
      this.setState({ timer: '' });
    }
  }
  
  render() {
    return <h2 style={{textAlign: 'center', color: 'red'}}>{this.state.timer}</h2>;
  }
}

/*
const AudioTimer = ({audioTimer_handler,clickArea,force_timerCount}) => {
  const [timer, setTimer] = React.useState('0:00');
  const [force_slideChange, setSlideChange] = React.useState(false);
  
  React.useEffect(() => {
    console.log("AudioTimer",clickArea,force_timerCount);
    if (force_timerCount) {
      timerCount = force_timerCount;
    }
    if (clickArea) {

      if (clickArea === 'recording') {
        // update quickly once
        timePrint = fmtMSS(Math.floor(timerCount));
        let tmp_slide_number = Math.floor(timerCount / 20) + 1;
        if (tmp_slide_number > 20) {
          setTimer('Final Remarks - '+timePrint);
        } else {
          setTimer('Recording - Slide '+tmp_slide_number+' - '+timePrint);
        }
        audioTimer_handler(timerCount);
        
        interval = setInterval(() => {
          timerCount = timerCount + (interval_ms / 1000);
          timePrint = fmtMSS(Math.floor(timerCount));
          let tmp_slide_number = Math.floor(timerCount / 20) + 1;
          if (tmp_slide_number > 20) {
            setTimer('Final Remarks - '+timePrint);
          } else {
            setTimer('Recording - Slide '+tmp_slide_number+' - '+timePrint);
          }
          //console.log("AudioTimer Interval",timerCount);
          audioTimer_handler(timerCount);
        }, interval_ms); 

      } else if (clickArea === 'paused') {
        clearInterval(interval);
        let tmp_slide_number = Math.floor(timerCount / 20) + 1;
        timerCount = timerCount - (timerCount % 20);
        timePrint = fmtMSS(Math.floor(timerCount));
        setTimer('Paused - Slide '+tmp_slide_number+' - '+timePrint);
        audioTimer_handler(timerCount);
      } else if (clickArea === 'inactive') {
        clearInterval(interval);
        setTimer('Finished '+timePrint);
        timerCount = 0;
      }
    }
  }, [clickArea]);

  React.useEffect(() => {
    return () => {
      // make sure timer is reset to zero. this can happen if we go "previous" then come back.
      console.log("Perform AudioTimer Cleanup");
      clearInterval(interval);
      timerCount = 0;
    }
  }, []);

  return (
    <h2 style={{textAlign: 'center', color: 'red'}}>{timer}</h2>
  )
}
*/

export default AudioTimer;
